import React from 'react';
import { Box } from '@heycater/design-system';
import { useRouter } from 'next/router';

import { EXPERIMENT, isVariationActive } from 'lib/ablyft';
import { Caterer } from 'lib/algolia/model';
import CatererCard from 'qualification/components/CatererCard';
import Question from 'qualification/components/Question';
import SurveyControls from 'qualification/components/Survey/SurveyControls';
import { useQualification } from 'qualification/context';
import { QUALIFICATION_STATUS } from 'qualification/context/model';
import { Step } from 'qualification/schema/model';
import { steps } from 'qualification/schema/steps';
import Container, { ContainerSize } from 'system/components/Container';

interface Props {
  step: Step;
  caterer?: Caterer;
}

function Survey({ step, caterer }: Props) {
  const {
    query: { reorder_offer_id },
  } = useRouter();

  const { actions, state } = useQualification();

  const { reorderOfferId } = state;

  if (reorder_offer_id && !reorderOfferId) {
    actions.setReorderOfferId(reorder_offer_id);
  }

  if (state.status !== QUALIFICATION_STATUS.answering) {
    return null;
  }

  const selectedCaterer = state.qualification.selectedCaterer;

  let containerSize: ContainerSize | number = 'sm';
  const stepId = state.qualification.step.id;
  if (selectedCaterer && stepId === 'event_date') {
    containerSize = 1100;
  }

  if (stepId.includes('tier')) {
    containerSize = 1200;
  }

  const containerMargins = {
    xs: 4,
    sm:
      stepId == steps.rareCustomerTierStep.id &&
      isVariationActive(EXPERIMENT.customerTierABC.variations.variationC)
        ? 0
        : 8,
  };

  const showSelectedCaterer = selectedCaterer && !stepId.includes('tier');

  return (
    <>
      <Box mt={containerMargins} id="survey-main">
        <Container
          size={containerSize}
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box
            mb={{ xs: 3, sm: 0 }}
            mr={{ xs: 0, sm: 2, md: 5 }}
            pb={{ xs: 0, sm: 4 }}
          >
            {selectedCaterer && showSelectedCaterer && (
              <CatererCard caterer={selectedCaterer} />
            )}
          </Box>
          <Box flexGrow={1}>
            <Question step={step} />
          </Box>
        </Container>
      </Box>
      <SurveyControls step={step} caterer={caterer} />
    </>
  );
}

export default Survey;
